import { render, staticRenderFns } from "./bankHolidayForm.vue?vue&type=template&id=6fa56540"
import script from "./bankHolidayForm.vue?vue&type=script&lang=js"
export * from "./bankHolidayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports